import React, { useMemo } from "react";

import * as THREE from "three";

import vertexShader from "../shaders/common.vert";

import fragmentShader from "../shaders/gooch.frag";

export default function GoochMaterial({
  surface,

  lightDirection = [0.5, 0.8, 1.0],

  lightColor = "#ffffff",
  lightIntensity = 1.0,
  ambientIntensity = 0.15,

  coolColor = "#3366cc",
  warmColor = "#ffb347",

  coolMix = 0.25,
  warmMix = 0.25,
}) {
  const uniforms = useMemo(
    () => ({
      uLightDirection: {
        value: new THREE.Vector3(),
      },

      uLightColor: {
        value: new THREE.Color(),
      },

      uLightIntensity: {
        value: 1.0,
      },

      uAmbientIntensity: {
        value: 0.15,
      },

      uBaseColor: {
        value: new THREE.Color(),
      },

      uBaseTexture: {
        value: null,
      },

      uHasBaseTexture: {
        value: false,
      },

      uNormalMap: {
        value: null,
      },

      uHasNormalMap: {
        value: false,
      },

      uNormalStrength: {
        value: 1.0,
      },

      uHeightMap: {
        value: null,
      },

      uHasHeightMap: {
        value: false,
      },

      uHeightStrength: {
        value: 0.05,
      },

      uAOMap: {
        value: null,
      },

      uHasAOMap: {
        value: false,
      },

      uEmissiveColor: {
        value: new THREE.Color(),
      },

      uEmissiveMap: {
        value: null,
      },

      uHasEmissiveMap: {
        value: false,
      },

      uTextureScale: {
        value: new THREE.Vector2(1, 1),
      },

      uTextureRotation: {
        value: 0.0,
      },

      /*
       * Gooch.
       */
      uCoolColor: {
        value: new THREE.Color(),
      },

      uWarmColor: {
        value: new THREE.Color(),
      },

      uCoolMix: {
        value: 0.25,
      },

      uWarmMix: {
        value: 0.25,
      },
    }),
    [],
  );

  uniforms.uLightDirection.value.set(...lightDirection).normalize();

  uniforms.uLightColor.value.set(lightColor);

  uniforms.uLightIntensity.value = lightIntensity;

  uniforms.uAmbientIntensity.value = ambientIntensity;

  uniforms.uBaseColor.value.set(surface.baseColor);

  uniforms.uBaseTexture.value = surface.baseTexture;

  uniforms.uHasBaseTexture.value = Boolean(surface.baseTexture);

  uniforms.uNormalMap.value = surface.normalMap;

  uniforms.uHasNormalMap.value = Boolean(surface.normalMap);

  uniforms.uNormalStrength.value = surface.normalStrength;

  uniforms.uHeightMap.value = surface.heightMap;

  uniforms.uHasHeightMap.value = Boolean(surface.heightMap);

  uniforms.uHeightStrength.value = surface.heightStrength;

  uniforms.uAOMap.value = surface.aoMap;

  uniforms.uHasAOMap.value = Boolean(surface.aoMap);

  uniforms.uEmissiveColor.value.set(surface.emissiveColor);

  uniforms.uEmissiveMap.value = surface.emissiveMap;

  uniforms.uHasEmissiveMap.value = Boolean(surface.emissiveMap);

  uniforms.uTextureScale.value.set(
    surface.textureScale[0],
    surface.textureScale[1],
  );

  uniforms.uTextureRotation.value = surface.textureRotation;

  uniforms.uCoolColor.value.set(coolColor);

  uniforms.uWarmColor.value.set(warmColor);

  uniforms.uCoolMix.value = coolMix;

  uniforms.uWarmMix.value = warmMix;

  return (
    <shaderMaterial
      vertexShader={vertexShader}

      fragmentShader={fragmentShader}

      uniforms={uniforms}

      side={THREE.DoubleSide}

      extensions={{
        derivatives: true,
      }}
    />
  );
}
